export const GRATITUDE_ASKS = {
  kid: ["I would be so grateful if you could please ", "I would really appreciate it if you could please ", "It would be so helpful if you could please "],
};

export const GRATITUDE_THANKS = {
  kid: ["Thank you so much, that really helped!", "I'm so grateful for your help, thank you!", "I really appreciate it, thank you!"],
};
